export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 text-white pt-16 pb-8 px-6 md:px-16">
      
      <div className="grid md:grid-cols-4 gap-10 mb-12">

        {/* Logo & About */}
        <div>
          <h2 className="text-2xl font-extrabold mb-4 bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
            AutoHelper AI
          </h2>
          <p className="text-blue-200 leading-relaxed">
            AI-powered smart helper auto-assignment and chatbot booking system 
            delivering instant service with intelligent automation.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
          <ul className="space-y-3 text-blue-200">
            {["Home", "Book Service", "How It Works", "Helper Panel"].map((item, index) => (
              <li key={index} className="hover:text-white transition duration-300 cursor-pointer">
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="font-semibold text-lg mb-4">Our Services</h3>
          <ul className="space-y-3 text-blue-200">
            {["Plumbing", "Electrical", "Cleaning", "AC Repair"].map((item, index) => (
              <li key={index} className="hover:text-white transition duration-300 cursor-pointer">
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-semibold text-lg mb-4">Contact</h3>
          <p className="text-blue-200 mb-2">📍 India</p>
          <p className="text-blue-200 mb-2">📧 support@autohelper.ai</p>
          <p className="text-blue-200">📞 +91 98765 43210</p>

          {/* Social Icons */}
          <div className="flex gap-4 mt-4">
            {["🌐", "📘", "📸", "🐦"].map((icon, index) => (
              <div
                key={index}
                className="w-10 h-10 flex items-center justify-center bg-blue-700 rounded-full hover:bg-white hover:text-blue-800 transition duration-300 cursor-pointer"
              >
                {icon}
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* Divider */}
      <div className="border-t border-blue-700 pt-6 text-center text-blue-300 text-sm">
        © {new Date().getFullYear()} AutoHelper AI. All rights reserved.
      </div>

    </footer>
  );
}
